import initialState from './systemHealthInitialState';
import mutations from './systemHealthMutation';
import actions from './systemHealthAction';

const getters = {
  systemHealthTableRecordCount: (state) => {
    const {
      tableData,
      shTableOptions: {
        itemsPerPage,
      },
    } = state;
    if (tableData.length === 0) {
      return 0;
    }
    return Math.ceil(tableData.length / itemsPerPage);
  },
  severeSystemCount: (state) => {
    const {
      completedProfile,
      incompletedProfile,
      activeProfileTab,
    } = state;
    let table = [];

    if (activeProfileTab === 'complete') {
      table = completedProfile;
    } else {
      table = incompletedProfile;
    }
    let count = 0;
    table.forEach((d) => {
      if (d.systemHealthRating === 'Severe') {
        count += 1;
      }
    });
    return count;
  },
  mildSystemCount: (state) => {
    const {
      completedProfile,
      incompletedProfile,
      activeProfileTab,
    } = state;
    let table = [];

    if (activeProfileTab === 'complete') {
      table = completedProfile;
    } else {
      table = incompletedProfile;
    }
    let count = 0;
    table.forEach((d) => {
      if (d.systemHealthRating === 'Mild') {
        count += 1;
      }
    });
    return count;
  },
  normalSystemCount: (state) => {
    const {
      completedProfile,
      incompletedProfile,
      activeProfileTab,
    } = state;
    let table = [];

    if (activeProfileTab === 'complete') {
      table = completedProfile;
    } else {
      table = incompletedProfile;
    }
    let count = 0;
    table.forEach((d) => {
      if (d.systemHealthRating === 'Normal') {
        count += 1;
      }
    });
    return count;
  },
  allCount: (state) => {
    const {
      activeProfileTab,
      completedProfile,
      incompletedProfile,
    } = state;

    if (activeProfileTab === 'complete') {
      return completedProfile.length;
    }

    return incompletedProfile.length;
  },
};

const systemHealthModule = {
  state: initialState(),
  mutations,
  actions,
  getters,
};

export default systemHealthModule;
